import { matchPath } from 'react-router-dom'
import { IResponse, IFileDownloadResponse } from '@common/interfaces/request'
import queryString from 'query-string'
import { Action } from 'redux'
import { takeEvery, put, call } from 'redux-saga/effects'
import { ROUTES } from '../../constants/routes'
import { download } from '../../helpers/helpers'
import { putPromise } from '../../helpers/redux'
import { DELETE_SUCCESS } from '../file/actions'
import { sagaNavigate } from '../navigationHelper'
import {
  UPLOAD_WIRES_SUCCESS,
  UPLOAD_CHECKS_SUCCESS,
  ADD_CHECK_ACCOUNT_SUCCESS,
  SAVE_CHECKS_SUCCESS,
  SAVE_WIRES_SUCCESS,
  UPLOAD_MID_DAY_WIRES_SUCCESS,
  SAVE_MID_DAY_WIRES_SUCCESS,
  EXPORT_AGGREGATION_SUCCESS,
  LIST_MID_DAY_WIRES_NEW_SUCCESS,
  listCheckAccounts,
  updateCheck,
  listMidDayWiresTotals,
  listWireFilesAndStatus,
  EXPORT_AGGREGATION_FAILURE,
  getChecksSummaryInfo,
  RESTORE_CHECK_SUCCESS,
  DELETE_CHECK_SUCCESS,
  UPDATE_CHECKS_SUCCESS,
  UPDATE_CHECK_SUCCESS,
  listNewWires,
  listDeletedWires,
  listMidDayWiresNew,
  listMidDayWiresDeleted,
} from './actions'

// Helper to get current URL query params
const getCurrentQuery = () => {
  return queryString.parse(window.location.search)
}

export function* uploadChecksSuccess() {
  yield takeEvery(UPLOAD_CHECKS_SUCCESS, function* () {
    yield putPromise(listCheckAccounts())
  })
}

export function* repullChecksInfo() {
  yield takeEvery(
    [
      RESTORE_CHECK_SUCCESS,
      DELETE_CHECK_SUCCESS,
      UPLOAD_CHECKS_SUCCESS,
      UPDATE_CHECKS_SUCCESS,
      UPDATE_CHECK_SUCCESS,
    ],
    function* () {
      const query = getCurrentQuery()
      yield putPromise(getChecksSummaryInfo({ activityId: query.activityId }))
    },
  )
}

export function* addCheckAccountSuccess() {
  yield takeEvery(
    [ADD_CHECK_ACCOUNT_SUCCESS],
    function* (action: IResponse & Action & { checkId: string; data: { accountNumber: string } }) {
      const { checkId } = action
      const data = action.data as { accountNumber: string }
      const { accountNumber } = data
      if (checkId) {
        yield putPromise(updateCheck(checkId, { accountNumber }))
      }
      yield putPromise(listCheckAccounts())
    },
  )
}

export function* refreshWiresAfterDelete() {
  yield takeEvery([DELETE_SUCCESS], function* () {
    const path = window.location.pathname
    const query = getCurrentQuery()
    if (query.activityId) {
      const activityId = query.activityId as string
      if (matchPath({ path: ROUTES.COLLECTIONS_MID_DAY_WIRES }, path)) {
        yield putPromise(listWireFilesAndStatus(activityId))
      } else if (matchPath({ path: ROUTES.COLLECTIONS_WIRES }, path)) {
        yield putPromise(listWireFilesAndStatus(activityId))
      }
    }
  })
}

export function* repullWiresFilesAndStatus() {
  yield takeEvery([UPLOAD_WIRES_SUCCESS, UPLOAD_MID_DAY_WIRES_SUCCESS], function* () {
    const query = getCurrentQuery()
    yield putPromise(listWireFilesAndStatus(query.activityId as string))
  })
}

export function* pullMidDayTotals() {
  yield takeEvery([LIST_MID_DAY_WIRES_NEW_SUCCESS], function* () {
    const query = getCurrentQuery()
    yield putPromise(listMidDayWiresTotals({ activityId: query.activityId }))
  })
}

export function* submitCollectionSuccess() {
  yield takeEvery(
    [SAVE_CHECKS_SUCCESS, SAVE_WIRES_SUCCESS, SAVE_MID_DAY_WIRES_SUCCESS],
    function* () {
      yield call(sagaNavigate, ROUTES.ACTIVITY_QUEUE)
    },
  )
}

export function* exportAggregation() {
  yield takeEvery(EXPORT_AGGREGATION_SUCCESS, function* (action: IFileDownloadResponse & Action) {
    try {
      yield download(action.data, action.data.name)
    } catch (error: unknown) {
      yield put({ type: EXPORT_AGGREGATION_FAILURE, error })
    }
  })
}

export function* uploadWireSuccess() {
  yield takeEvery([UPLOAD_WIRES_SUCCESS], function* () {
    const query = getCurrentQuery()
    if (query.activityId) {
      yield putPromise(listNewWires({ activityId: query.activityId }))
      yield putPromise(listDeletedWires({ activityId: query.activityId }))
    }
  })
}

export function* updateMidDayWireSuccess() {
  yield takeEvery([UPLOAD_MID_DAY_WIRES_SUCCESS], function* () {
    const query = getCurrentQuery()
    if (query.activityId) {
      yield putPromise(listMidDayWiresNew({ activityId: query.activityId }))
      yield putPromise(listMidDayWiresDeleted({ activityId: query.activityId }))
    }
  })
}
